import About from "./About";
import FintrafficServices from "./FintrafficServices";
import Support from "./Support";

export const AdditionalMenuSection = () => {
  return (
    <>
      <About />
      <Support />
      <FintrafficServices />
    </>
  );
};
